import { render, staticRenderFns } from "./vehicleequipmentrepair.vue?vue&type=template&id=867d05f2&scoped=true"
import script from "./vehicleequipmentrepair.vue?vue&type=script&lang=js"
export * from "./vehicleequipmentrepair.vue?vue&type=script&lang=js"
import style0 from "./vehicleequipmentrepair.vue?vue&type=style&index=0&id=867d05f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867d05f2",
  null
  
)

export default component.exports